import { render, staticRenderFns } from "./AssessStatistics.vue?vue&type=template&id=7480b358&scoped=true&"
import script from "./AssessStatistics.vue?vue&type=script&lang=js&"
export * from "./AssessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AssessStatistics.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./AssessStatistics.vue?vue&type=style&index=1&id=7480b358&scoped=true&lang=scss&"
import style2 from "./AssessStatistics.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480b358",
  null
  
)

export default component.exports